// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientInfo_root__YB6fQ","info":"PatientInfo_info__IPxsk"};